module.exports = __webpack_public_path__ + "static/media/Technische_Hochschule_Mittelhessen.ab4595d5.svg";